import {BiSolidTrain} from "react-icons/bi";

/**
 * Zwraca ikonę pociągu
 * @returns {JSX.Element}
 * @constructor
 */
export default function Train() {
    return <BiSolidTrain/>
}
